function ZipCodeCheckModal(el) {
    this.el = el;

    this.focusedElBeforeOpen = null;
    this.focusableEls = this.el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];

    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsCloseModal')) this.hide();
    });

    window.addEventListener('keyup', e => {
        if (e.key.toLowerCase() === 'escape') this.hide();
    });

    window.addEventListener('keydown', e => {
        const tabIsPressed = e.key === 'Tab';

        if (!tabIsPressed) return;

        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableEl) {
                this.lastFocusableEl.focus();
                e.preventDefault();
            }
        }
        else {
            if (document.activeElement === this.lastFocusableEl) {
                this.firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    });
}

ZipCodeCheckModal.prototype.show = function() {
    if (this.el.classList.contains('show')) return;

    // Animation
    gsap.timeline()
        .set(this.el, { y: 20, display: 'flex', opacity: 0 })
        .to(this.el, 0.5, { y: 0, opacity: 1, ease: Power2.easeInOut })
        
        .add(_ => {
            this.el.classList.add('show');
            window.location.hash = 'postcodecheck';

            // Set focus to the input field
            setTimeout(_ => this.el.querySelector('.jsZipCodeCheckInput').focus(), 200);
        })
        .set(this.el, { clearProps: 'all' })
    ;

    // Prevent overflow on the HTML and body
    document.documentElement.classList.add('no-overflow');
    document.body.classList.add('no-overflow');

    // Accessibility stuff
    this.focusedElBeforeOpen = document.activeElement;
    this.firstFocusableEl.focus();
    document.body.ariaHidden = true;
    this.el.ariaHidden = false;
};

ZipCodeCheckModal.prototype.hide = function() {
    // Animation
    gsap.timeline()
        .to(this.el, 0.5, { y: 20, opacity: 0, ease: Power2.easeInOut })

        .add(_ => {
            this.el.classList.remove('show');
            if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();
            this.focusedElBeforeOpen = null;
            window.location.hash = '';
        })
        .set(this.el, { clearProps: 'all' })
    ;

    document.documentElement.classList.remove('no-overflow');
    document.body.classList.remove('no-overflow');

    // Accessibility stuff
    if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();
    document.body.ariaHidden = false;
    this.el.ariaHidden = true;
};

(function() {
    const zipCodeCheckModalEl = document.querySelector('.jsZipCodeModal');
    if (zipCodeCheckModalEl) {
        const zipCodeCheckModal = new ZipCodeCheckModal(zipCodeCheckModalEl);

        document.body.addEventListener('click', e => {
            if (e.target.classList.contains('jsZipCodeCheckModalTrigger')) {
                e.preventDefault();
                zipCodeCheckModal.show();
            }
        });

        // Check if we have the zipcode trigger hashtag and if, open the zipcode check modal
        if (window.location.hash === '#postcodecheck') {
            zipCodeCheckModal.show();
        }
    }
})();